module.exports = "/_next/static/images/icon_bundle_24-4555910d6614c4195133718291377e34.png";